import * as filtering from "../constants/filtering";
import * as formatHelper from "./formatHelper";

export const getFilteringParams = (tabId, state, scene = null) => {
    let storeScene = scene !== null ? state[scene].filterType : state.toDispense.filterType;
    let params = {
        colorStatsTypeIds: [],
        productList: [],
        fandeckList: [],
        formulaList: [],
        baseList: [],
        packageList: [],
        customerList: [],
        statusList: [],
        dateFrom: null,
        dateTo: null,
        searchByColumns: null,
        minNominalAmount: null,
        maxNominalAmount: null,
        clientName: null
    };

    if (state.filtering[tabId] !== undefined) {
        params.productList = formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedProductList);
        params.fandeckList = formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedFandeckList);
        params.formulaList = [
            ...formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedFormulaList),
            ...formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedFormulaCodeList)
        ];
        params.baseList = formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedBaseList);
        params.packageList = [
            ...formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedPackageList),
            ...formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedBippList)
        ];
        params.customerList = formatHelper.formatFilteringObjectsToNames(state.filtering[tabId].selectedCustomerList);
        params.statusList = state.filtering[tabId].selectedStatusList;
        params.dateFrom =
            state.filtering[tabId].dateFrom !== null
                ? formatHelper.formatDateTimeForServer(state.filtering[tabId].dateFrom)
                : null;
        params.dateTo =
            state.filtering[tabId].dateTo !== null
                ? formatHelper.formatDateTimeForServer(state.filtering[tabId].dateTo)
                : null;
        params.searchByColumns = {};

        if (state.filtering[tabId].selectedColorStatsTypeList.length > 0) {
            params.colorStatsTypeIds = state.filtering[tabId].selectedColorStatsTypeList;
        }

        if (state.filtering[tabId].customProductList.length > 0) {
            params.searchByColumns.product_name = state.filtering[tabId].customProductList;
        }

        if (state.filtering[tabId].customFandeckList.length > 0) {
            params.searchByColumns.fandeck_name = state.filtering[tabId].customFandeckList;
        }

        if (state.filtering[tabId].customFormulaList.length > 0) {
            params.searchByColumns.color_name = state.filtering[tabId].customFormulaList;
        }

        if (state.filtering[tabId].customFormulaCodeList.length > 0) {
            params.searchByColumns.color_code = state.filtering[tabId].customFormulaCodeList;
        }

        if (state.filtering[tabId].customBaseList.length > 0) {
            params.searchByColumns.base_name = state.filtering[tabId].customBaseList;
        }

        if (state.filtering[tabId].customPackageList.length > 0) {
            params.searchByColumns.package_name = state.filtering[tabId].customPackageList;
        }

        if (state.filtering[tabId].customBippList.length > 0) {
            params.searchByColumns.bipp_name = state.filtering[tabId].customBippList;
        }

        if (state.filtering[tabId].customCustomerList.length > 0) {
            params.searchByColumns.customer_name = state.filtering[tabId].customCustomerList;
        }

        if (state.filtering[tabId].filterOperator !== "") {
            params.searchByColumns.user_login = state.filtering[tabId].filterOperator;
        }

        if (state.filtering[tabId].filterBuildingSite !== "") {
            params.searchByColumns.building_site = state.filtering[tabId].filterBuildingSite;
        }

        if (state.filtering[tabId].filterPackageCount !== "") {
            params.searchByColumns.package_count = state.filtering[tabId].filterPackageCount;
        }

        if (state.filtering[tabId].filterMoreInfo !== "") {
            params.searchByColumns.more_info = state.filtering[tabId].filterMoreInfo;
        }

        if (state.filtering[tabId].filterMoreInfoInternal !== "") {
            params.searchByColumns.more_info_internal = state.filtering[tabId].filterMoreInfoInternal;
        }

        if (state.filtering[tabId].clientName !== "") {
            params.searchByColumns.client_name = state.filtering[tabId].clientName;
        }

        if (Object.keys(params.searchByColumns).length === 0) {
            params.searchByColumns = null;
        }
    }

    if (!state.module.weberSoftware) {
        return params;
    }

    switch (storeScene) {
        case filtering.LABORATORY:
            params.minNominalAmount = state.settings.weberCanLaboratoryLowerBound;
            params.maxNominalAmount = state.settings.weberCanLaboratoryUpperBound;
            break;
        case filtering.PLASTER_SMALL:
            params.minNominalAmount = state.settings.weberCanSmallLowerBound;
            params.maxNominalAmount = state.settings.weberCanSmallUpperBound;
            params.productList = state.settings.weberPlasterNames;
            break;
        case filtering.PLASTER_BIG:
            params.minNominalAmount = state.settings.weberCanBigLowerBound;
            params.maxNominalAmount = state.settings.weberCanBigUpperBound;
            params.productList = state.settings.weberPlasterNames;
            break;
        case filtering.COATING:
            params.minNominalAmount = state.settings.weberCanCoatingLowerBound;
            params.maxNominalAmount = state.settings.weberCanCoatingUpperBound;
            params.productList = state.settings.weberCoatingNames;
            break;
        default:
            break;
    }

    return params;
};

export const getMinMaxNominalAmountsByFilterType = (filterType, settings) => {
    switch (filterType) {
        case filtering.LABORATORY:
            return [settings.weberCanLaboratoryLowerBound, settings.weberCanLaboratoryUpperBound];
        case filtering.PLASTER_SMALL:
            return [settings.weberCanSmallLowerBound, settings.weberCanSmallUpperBound];
        case filtering.PLASTER_BIG:
            return [settings.weberCanBigLowerBound, settings.weberCanBigUpperBound];
        case filtering.COATING:
            return [settings.weberCanCoatingLowerBound, settings.weberCanCoatingUpperBound];
        default:
            return [null, null];
    }
};

export const getProductNamesByFilterType = (filterType, settings) => {
    switch (filterType) {
        case filtering.PLASTER_SMALL:
        case filtering.PLASTER_BIG:
            return settings.weberPlasterNames;
        case filtering.COATING:
            return settings.weberCoatingNames;
        default:
            return [];
    }
};
